import api from '../util/instance';
import { urls } from './Api';

export const getNotification = async () => api.get(urls.Notification);
